import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {
  AutoSizer,
  CellMeasurer,
  CellMeasurerCache,
  createMasonryCellPositioner,
  Masonry,
} from 'react-virtualized';

const DEFAULT_PHOTO_HEIGHT = 200;
const DEFAULT_PHOTO_WIDTH = 200;

class VirtualizedPhotoList extends Component {
  constructor(props) {
    super(props);

    this.cache = new CellMeasurerCache({
      defaultHeight: DEFAULT_PHOTO_HEIGHT,
      defaultWidth: DEFAULT_PHOTO_WIDTH,
      fixedWidth: true,
    });

    this.cellPositioner = createMasonryCellPositioner({
      cellMeasurerCache: this.cache,
      columnCount: 3,
      columnWidth: DEFAULT_PHOTO_WIDTH,
      spacer: 0,
    });

    this.listRef = null;

    this.onResize = this.onResize.bind(this);
    this.recompute = this.recompute.bind(this);
    this.renderListItem = this.renderListItem.bind(this);
    this.resetCellPositioner = this.resetCellPositioner.bind(this);
  }

  componentDidMount() {
    window.addEventListener('resize', this.onResize);
    this.recompute();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  onResize() {
    if (this.listRef) {
      this.resetCellPositioner();
      this.listRef.recomputeCellPositions();
    }
  }

  recompute() {
    if (this.listRef) {
      this.resetCellPositioner();
      this.listRef.clearCellPositions();
      this.listRef.recomputeCellPositions();
    }
  }

  resetCellPositioner() {
    const columnCount = _.floor(_.get(this.wrapperRef, 'offsetWidth') / DEFAULT_PHOTO_WIDTH);
    this.cache.clearAll();
    this.cellPositioner.reset({
      columnCount,
      columnWidth: DEFAULT_PHOTO_WIDTH,
      spacer: 0,
    });
  }

  renderListItem({ index, key, parent, style }) {
    const { collection, renderItem } = this.props;
    const item = collection[index];

    if (item) {
      return (
        <CellMeasurer cache={this.cache} index={index} key={key} parent={parent}>
          <div style={style}>{renderItem(item, index)}</div>
        </CellMeasurer>
      );
    }

    return null;
  }

  render() {
    const { collection, heightOfList } = this.props;
    const masonryHeight = heightOfList || this.cache.defaultHeight;

    return (
      <div
        className="virtualized-vertical-photo-list"
        style={{ height: masonryHeight }}
        ref={wrapperRef => {
          this.wrapperRef = wrapperRef;
        }}
      >
        <AutoSizer>
          {({ width }) => (
            <Masonry
              cellCount={collection.length}
              cellMeasurerCache={this.cache}
              cellPositioner={this.cellPositioner}
              cellRenderer={this.renderListItem}
              height={masonryHeight}
              width={width}
              ref={listRef => {
                this.listRef = listRef;
              }}
            />
          )}
        </AutoSizer>
      </div>
    );
  }
}

VirtualizedPhotoList.propTypes = {
  collection: PropTypes.arrayOf(PropTypes.any).isRequired,
  heightOfList: PropTypes.number,
  renderItem: PropTypes.func.isRequired,
};

VirtualizedPhotoList.defultProps = {
  heightOfList: 200,
};

export default VirtualizedPhotoList;
